import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import TextareaCounter from '../../FormComponents/TextareaCounter';

export default class HiddenPreferences extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldErrors: {},
    };

    this.rescheduleDurationOptions = [
      {
        label: '1 hour',
        value: 'PT1H',
      },
      {
        label: '2 hours',
        value: 'PT2H',
      },
      {
        label: '3 hours',
        value: 'PT3H',
      },
      {
        label: '6 hours',
        value: 'PT6H',
      },
      {
        label: '8 hours',
        value: 'PT8H',
      },
      {
        label: '12 hours',
        value: 'PT12H',
      },
      {
        label: '18 hours',
        value: 'PT18H',
      },
      {
        label: '24 hours',
        value: 'PT24H',
      },
      {
        label: '48 hours',
        value: 'PT48H',
      },
      {
        label: '72 hours',
        value: 'PT72H',
      },
      {
        label: 'NONE',
        value: 'PT0S',
      },
    ];

    this.customStyles = {
      menu: (provided) => ({
        ...provided,
        zIndex: 3,
      }),
      control: (provided) => ({
        ...provided,
        minHeight: '50px',
        borderColor: '#cfd0d1',
      }),
    };

    this.handleChange = this.handleChange.bind(this);
    this.onRescheduleApptWithinDurationChange = this.onRescheduleApptWithinDurationChange.bind(this);
    this.onSchedulingFieldChange = this.onSchedulingFieldChange.bind(this);
    this.onRescheduleDurationChange = this.onRescheduleDurationChange.bind(this);
    this.onAmenityChange = this.onAmenityChange.bind(this);
    this.onFaqsFieldChange = this.onFaqsFieldChange.bind(this);
    this.setFieldError = this.setFieldError.bind(this);
    this.getFieldError = this.getFieldError.bind(this);
    this.onSendStaffInfo = this.onSendStaffInfo.bind(this);
    this.onCustomPostBookingInstructionsChange = this.onCustomPostBookingInstructionsChange.bind(this);
  }

  static validateStringField(value, fieldName, maxLength = null, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    if (typeof processedValue !== 'string') {
      return { message: `${fieldName} must be a string` };
    }

    if (required && processedValue.trim() === '') {
      return { message: `${fieldName} is required` };
    }

    if (maxLength && processedValue.length > maxLength) {
      return { message: `${fieldName} is too long (maximum ${maxLength} characters)` };
    }

    if (processedValue.trim() !== '') {
      const trimmedValue = processedValue.trim();

      if (/^\d+$/.test(trimmedValue)) {
        return { message: `${fieldName} cannot contain only numbers` };
      }

      if (/^[^a-zA-Z0-9]+$/.test(trimmedValue)) {
        return { message: `${fieldName} cannot contain only special characters` };
      }

      if (!/[a-zA-Z]/.test(trimmedValue)) {
        return { message: `${fieldName} must contain at least one letter` };
      }
    }

    return null;
  }

  setFieldError(fieldName, error) {
    if (this.props.onErrorChange) {
      this.props.onErrorChange(fieldName, error);
    } else {
      this.setState((prevState) => ({
        fieldErrors: {
          ...prevState.fieldErrors,
          [fieldName]: error,
        },
      }));
    }
  }

  getFieldError(fieldName) {
    return (this.props.errors && this.props.errors[fieldName])
           || (this.state.fieldErrors && this.state.fieldErrors[fieldName]);
  }

  handleChange(fieldName, value, isNested, nestedParent) {
    let eventData;

    if (isNested && nestedParent) {
      const currentParentData = this.props.details[nestedParent] || {};
      eventData = {
        target: {
          name: nestedParent,
          value: {
            ...currentParentData,
            [fieldName]: value,
          },
        },
      };
    } else {
      eventData = {
        target: {
          name: fieldName,
          value,
        },
      };
    }
    this.props.onChange(eventData);
  }

  onRescheduleApptWithinDurationChange() {
    const currentValue = this.props.details.scheduling?.reschedule_appt_within_duration;
    const newValue = !currentValue;
    this.handleChange('reschedule_appt_within_duration', newValue, true, 'scheduling');
  }

  onSchedulingFieldChange(field, value) {
    this.handleChange(field, value, true, 'scheduling');
  }

  onRescheduleDurationChange(item) {
    const value = item && item.value ? item.value : null;
    this.handleChange('reschedule_duration', value, true, 'scheduling');
  }

  onAmenityChange(amenityType) {
    let fieldName;
    if (amenityType === 'WIFI') {
      fieldName = 'amenities_wifi_available';
    } else if (amenityType === 'REFRESHMENTS') {
      fieldName = 'amenities_refreshments_available';
    }
    const currentValue = Boolean(this.props.details[fieldName]);
    const newValue = !currentValue;

    this.handleChange(fieldName, newValue, false, null);
  }

  onFaqsFieldChange(field, value) {
    // Validate the FAQ fields with string validation
    let validationError = null;
    if (field === 'anxious_patient') {
      validationError = HiddenPreferences.validateStringField(value, 'What to say to anxious patients', 500, false);
      this.setFieldError('anxious_patient', validationError);
    } else if (field === 'sales_pitch_new_patient') {
      validationError = HiddenPreferences.validateStringField(value, 'Why choose us', 500, false);
      this.setFieldError('sales_pitch_new_patient', validationError);
    }

    const eventData = {
      target: {
        name: field,
        value,
      },
    };
    this.props.onChange(eventData);
  }

  getFaqValue(fieldName) {
    const value = this.props.details[fieldName];
    if (value === undefined || value === null) {
      return '';
    }
    return String(value);
  }

  static getSelectedOption(options, value) {
    return options.find((option) => option.value === value) || null;
  }

  getAmenityValue(amenityType) {
    if (amenityType === 'WIFI') {
      return this.props.details.amenities_wifi_available || false;
    } else if (amenityType === 'REFRESHMENTS') {
      return this.props.details.amenities_refreshments_available || false;
    }
    return false;
  }

  onSendStaffInfo() {
    // const details = this.getPreferencesData();
    const { details } = this.props;
    const newValue = !details.send_staff_info;
    this.props.onChange({
      target: {
        type: 'checkbox',
        name: 'send_staff_info',
        checked: newValue,
        value: newValue,
      },
    });
  }

  static validateJSONField(value, fieldName, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    if (typeof processedValue !== 'string') {
      return { message: 'There must be a string' };
    }

    if (!processedValue || processedValue.trim() === '') {
      return null;
    }

    const trimmedValue = processedValue.trim();
    if (!trimmedValue.startsWith('{') || !trimmedValue.endsWith('}')) {
      return { message: 'The value must be a valid JSON object (e.g., {"key": "value"})' };
    }

    try {
      const parsed = JSON.parse(trimmedValue);
      if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
        return { message: 'The value must be a valid JSON object' };
      }
      return null;
    } catch (error) {
      return { message: 'The value contains invalid JSON syntax' };
    }
  }

  static safeStringifyJSON(obj) {
    try {
      if (typeof obj === 'string') {
        if (!obj || obj.trim() === '') {
          return '';
        }

        try {
          const parsed = JSON.parse(obj);
          return JSON.stringify(parsed, null, 2);
        } catch {
          return obj;
        }
      }

      if (obj === null || obj === undefined) {
        return '';
      }

      if (typeof obj === 'object') {
        return JSON.stringify(obj, null, 2);
      }

      return String(obj);
    } catch (error) {
      return '';
    }
  }

  onCustomPostBookingInstructionsChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateJSONField(value, 'Are there any specific post-booking messages you would like TL to share?', true);
    this.setFieldError('custom_post_booking_instructions', validationError);
    this.handleChange('custom_post_booking_instructions', value);
  }

  render() {
    const { details, errors, setRef, disabled } = this.props;
    const scheduling = details.scheduling || {};

    const selectedRescheduleDuration = HiddenPreferences.getSelectedOption(
      this.rescheduleDurationOptions,
      scheduling.reschedule_duration,
    );

    return (
      <div className="bookings scheduling hidden-preferences">
        <div className="bookings__section">
          <h4 style={{ marginBottom: '0' }}>Scheduling</h4>
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Reschedule Appointment Within Duration</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={scheduling.reschedule_appt_within_duration === true || scheduling.reschedule_appt_within_duration === 'true'}
                name="reschedule_appt_within_duration"
                onChange={this.onRescheduleApptWithinDurationChange}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Reschedule Duration</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={selectedRescheduleDuration}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.rescheduleDurationOptions}
                styles={this.customStyles}
                onChange={this.onRescheduleDurationChange}
                disabled={disabled}
                placeholder="Select reschedule duration"
                isClearable
              />
              <span className="message--small message--error">
                {errors.reschedule_duration && errors.reschedule_duration.message}
              </span>
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">RESCHEDULE CHARGES</p>
            <div className="bookings__row__input">
              <input
                type="text"
                placeholder="e.g., 50%, $25"
                name="reschedule_charges"
                value={scheduling.reschedule_charges || ''}
                onChange={(e) => {
                  this.onSchedulingFieldChange('reschedule_charges', e.target.value);
                }}
                className={classnames({
                  'has-error': errors.reschedule_charges,
                })}
                ref={setRef}
                disabled={disabled}
              />
              <span className="message--small message--error">
                {errors.reschedule_charges && errors.reschedule_charges.message}
              </span>
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">CANCELLATION CHARGES</p>
            <div className="bookings__row__input">
              <input
                type="text"
                placeholder="e.g., 50%, $25"
                name="cancellation_charges"
                value={scheduling.cancellation_charges || ''}
                onChange={(e) => {
                  this.onSchedulingFieldChange('cancellation_charges', e.target.value);
                }}
                className={classnames({
                  'has-error': errors.cancellation_charges,
                })}
                ref={setRef}
                disabled={disabled}
              />
              <span className="message--small message--error">
                {errors.cancellation_charges && errors.cancellation_charges.message}
              </span>
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <h4 style={{ marginBottom: '0' }}>Amenities</h4>
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Wi-Fi Available</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={this.getAmenityValue('WIFI')}
                name="wifi_available"
                onChange={() => {
                  this.onAmenityChange('WIFI');
                }}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Refreshments Available</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={this.getAmenityValue('REFRESHMENTS')}
                name="refreshments_available"
                onChange={() => {
                  this.onAmenityChange('REFRESHMENTS');
                }}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        {/* New FAQs Section */}
        <div className="bookings__section">
          <h4 style={{ marginBottom: '0' }}>FAQ Responses</h4>
          <div className="bookings__row">
            <p className="bookings__row__label">What to say to anxious patients</p>
            <div className="bookings__row__input">
              <span className="message--small message--error">
                {this.getFieldError('anxious_patient') && this.getFieldError('anxious_patient').message}
              </span>
              <TextareaCounter
                count
                maxLength={500}
                label=""
                name="anxious_patient"
                placeholder="How to handle anxious patients..."
                value={this.getFaqValue('anxious_patient')}
                onChange={(e) => {
                  this.onFaqsFieldChange('anxious_patient', e.target.value);
                }}
                className={classnames({
                  'has-error': this.getFieldError('anxious_patient'),
                })}
                ref={setRef}
                disabled={disabled}
              />
            </div>
          </div>
          <div className="bookings__row">
            <p className="bookings__row__label">Why choose us?</p>
            <div className="bookings__row__input">
              <span className="message--small message--error">
                {this.getFieldError('sales_pitch_new_patient') && this.getFieldError('sales_pitch_new_patient').message}
              </span>
              <TextareaCounter
                count
                maxLength={500}
                label=""
                name="sales_pitch_new_patient"
                placeholder="Sales pitch for new patients..."
                value={this.getFaqValue('sales_pitch_new_patient')}
                onChange={(e) => {
                  this.onFaqsFieldChange('sales_pitch_new_patient', e.target.value);
                }}
                className={classnames({
                  'has-error': this.getFieldError('sales_pitch_new_patient'),
                })}
                ref={setRef}
                disabled={disabled}
              />
            </div>
          </div>
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Send staff info in replies?</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.send_staff_info}
                name="send_staff_info"
                onChange={this.onSendStaffInfo}
                disabled={disabled}
              />
            </div>
          </div>
          <div className="bookings__section">
            <div className="bookings__row" style={{ alignItems: 'flex-start' }}>
              <p className="bookings__row__label">Are there any specific post-booking messages you would like TL to share?</p>
              <small>Please modify the fields within the JSON object. Clearing the entire object will reset it to its default values.</small>
              <div className="bookings__row__input">
                <span className="message--small message--error">
                  {this.getFieldError('custom_post_booking_instructions') && this.getFieldError('custom_post_booking_instructions').message}
                </span>
                <TextareaCounter
                  rows="4"
                  name="custom_post_booking_instructions"
                  value={HiddenPreferences.safeStringifyJSON(details.custom_post_booking_instructions)}
                  onChange={this.onCustomPostBookingInstructionsChange}
                  className={classnames({
                    'has-error': errors.custom_post_booking_instructions,
                  })}
                  ref={setRef}
                  maxLength={2000}
                  disabled={disabled}
                  placeholder={'{"BUSINESS": [{"type_id": "504318", "instructions": "Your instructions here"}]}'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HiddenPreferences.defaultProps = {
  onChange: () => {},
  setRef: () => {},
  details: {},
  errors: {},
  disabled: false,
};

HiddenPreferences.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  details: PropTypes.shape(),
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
  onErrorChange: PropTypes.func,
};
